import React from 'react'
import NumberInput from '../NumberInput/NumberInput'
import TextInput from '../TextInput/TextInput'

const ShortText = (props) => {
  if (props.json_key === 'national_number') return <NumberInput {...props} />
  return <TextInput {...props} />
}
export default ShortText
